import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'

export const DeleteScimConfigurationPopup = ({ isOpen, onClose, onDelete }) => (
  <SimplePopup
    isDestructive
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onDelete}
    title={I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.delete_scim_configuration_popup.title')}
    cancelLabel={I18n.t('publisher.action.cancel')}
    confirmLabel={I18n.t('publisher.action.delete')}
  >
    {HtmlParser(I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.delete_scim_configuration_popup.body'))}
  </SimplePopup>
)
